import {AfterViewInit, Component, inject, signal, ViewChild} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {OrganizationService} from '../../services/organization.service';
import {EventService} from '../../services/event.service';
import {RecurringEvent, eventTypeEnum} from '../../../models/event';
import dayjs from 'dayjs';

@Component({
  selector: 'app-recurring-events',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './recurring-events.component.html',
  styleUrl: './recurring-events.component.scss'
})
export class RecurringEventsComponent implements AfterViewInit {
  organizationService = inject(OrganizationService);
  eventService = inject(EventService);

  displayedColumns: string[] = ['name', 'type', 'eventsCount', 'firstDate', 'lastDate', 'startTime', 'endTime'];
  dataSource: MatTableDataSource<RecurringEvent> = new MatTableDataSource();
  loading = signal(false);

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  eventTypeEnum: {[key: string]: string} = eventTypeEnum;

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  async onOrgChange(orgId: string) {
    this.loading.set(true);
    try {
      const events = await this.eventService.getRecurring(orgId);
      this.dataSource.data = events;
    } finally {
      this.loading.set(false);
    }
  }

  formatDate(timestamp: number): string {
    return dayjs.unix(timestamp).format('DD/MM/YYYY');
  }

  formatTime(timestamp: number): string {
    return dayjs.unix(timestamp).format('HH:mm');
  }
}
